/* eslint-disable no-unused-vars */
// linter gives a false-positive for typescript-enums, needs to investigate
export enum StepEditorContentConfigureStageTypeEnum {
  NEW = 'new',
  CONFIGURE = 'configure',
  ANNOTATION = 'annotation',
  BEHAVIOR = 'behavior',
  BOARD = 'board',
}
